function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function classNames() {
  for (var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++) {
    classes[_key] = arguments[_key];
  }

  return classes.filter(Boolean).join(' ');
}

function variationName(name, value) {
  return "".concat(name).concat(value.charAt(0).toUpperCase()).concat(value.slice(1));
}

function sanitizeCustomProperties(styles) {
  var nonNullValues = Object.entries(styles).filter(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        _ = _ref2[0],
        value = _ref2[1];

    return value != null;
  });
  return nonNullValues.length ? Object.fromEntries(nonNullValues) : undefined;
}

function getResponsiveProps(componentName, componentProp, tokenSubgroup, responsiveProp) {
  if (!responsiveProp) return {};

  if (typeof responsiveProp === 'string') {
    return _defineProperty({}, "--pc-".concat(componentName, "-").concat(componentProp, "-xs"), "var(--p-".concat(tokenSubgroup, "-").concat(responsiveProp, ")"));
  }

  return Object.fromEntries(Object.entries(responsiveProp).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
        breakpointAlias = _ref5[0],
        aliasOrScale = _ref5[1];

    return ["--pc-".concat(componentName, "-").concat(componentProp, "-").concat(breakpointAlias), "var(--p-".concat(tokenSubgroup, "-").concat(aliasOrScale, ")")];
  }));
}

function getResponsiveValue(componentName, componentProp, responsiveProp) {
  if (!responsiveProp) return {};

  if (typeof responsiveProp === 'string') {
    return _defineProperty({}, "--pc-".concat(componentName, "-").concat(componentProp, "-xs"), responsiveProp);
  }

  return Object.fromEntries(Object.entries(responsiveProp).map(function (_ref7) {
    var _ref8 = _slicedToArray(_ref7, 2),
        breakpointAlias = _ref8[0],
        responsiveValue = _ref8[1];

    return ["--pc-".concat(componentName, "-").concat(componentProp, "-").concat(breakpointAlias), responsiveValue];
  }));
}

export { classNames, getResponsiveProps, getResponsiveValue, sanitizeCustomProperties, variationName };